var render = function render(){var _vm=this,_c=_vm._self._c;return _c('formula-form',{attrs:{"edit":""},on:{"update":_vm.onUpdate},model:{value:(_vm.formula),callback:function ($$v) {_vm.formula=$$v},expression:"formula"}})
}
var staticRenderFns = []

export { render, staticRenderFns }